import React, { useEffect, useState } from 'react';
import { getRandomImage, getRecommendedCoursesAPI, pathwaySearchDataAPI } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../hooks/useDebounce';

export const PathwaySearch = ({
  popUpCallBack,
  setPathwayData,
  pathwayData,
  selectedData,
  setSelectedData,
}) => {
  const [searchedData, setSearchedData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslation('library');

  const getImageURL = (data) => {
    return process.env.REACT_APP_IBL_LMS_URL + data?.data?.edx_data?.course_image_asset_path;
  };

  const handleImageError = (e) => {
    e.target.src = getRandomImage();
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchTerm(inputValue);
  };

  useDebounce(()=>{
    if(String(searchTerm).length > 1){
      getRecommendedCoursesAPI(searchTerm, (data) => {
        setSearchedData(data ?? []);
      })
    }else{
      setSearchedData([]);
    }
  }, 300, [searchTerm])

  const handleSelectedData = (data) => () => {
    const dataIndex = selectedData.findIndex(
      (selectedItem) => selectedItem.id === data?.data?.id
    );

    if (dataIndex === -1) {
      setSelectedData([...selectedData, data]);
    } else {
      // If already selected, do nothing
    }
  };

  const handleDeselection = (data) => () => {
    const newSelectedData = selectedData.filter(
      (selectedItem) => selectedItem.id !== data?.data?.id
    );
    setSelectedData(newSelectedData);
  };

  const handleCloseModal = () => {
    setSearchedData([]);
    setSelectedData([]);
    popUpCallBack(false);
  };

  const handleAddContentBtnClick = () => {
    setPathwayData([...pathwayData, ...selectedData]);
    setSearchedData([]);
    setSelectedData([]);
    popUpCallBack(false);
  };

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .c_box {
              display: -webkit-box;
              display: -webkit-flex;
              display: -ms-flexbox;
              display: flex;
              width: 100%;
              height: auto;
              margin-right: 0px;
              margin-bottom: 12px;
              -webkit-box-pack: start;
              -webkit-justify-content: flex-start;
              -ms-flex-pack: start;
              justify-content: flex-start;
              -webkit-box-align: stretch;
              -webkit-align-items: stretch;
              -ms-flex-align: stretch;
              align-items: stretch;
              border: 1px solid #dde1e6;
              border-radius: 4px;
              background-color: hsla(0, 0%, 100%, 0.33);
              cursor: pointer;
            }
          `,
        }}
      />

      <div className="popup_div active">
        <div className="popup_cont sk">
          <div className="add_skill_popup active">
            <div className="div-block-520">
              <div>{t('Add Content')}</div>
              <img
                src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
                loading="lazy"
                alt=""
                onClick={handleCloseModal}
                className="cancel_add_skill"
              />
            </div>
            <div className="div-block-525">
              <div className="div-block-469 sk_s">
                <div className="form-block-15 s_skill w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="form-10"
                    data-wf-page-id="6596f6f119932dba27256924"
                    data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371da"
                    aria-label="Email Form"
                  >
                    <div className="div-block-410">
                      <img
                        src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacc8_magnifying-glass.png"
                        loading="lazy"
                        alt=""
                        className="image-164"
                      />
                    </div>
                    <input
                      className="text-field-14 n_text w-input"
                      name="searchContent"
                      data-name="searchContent"
                      placeholder={t('Search for content')}
                      type="text"
                      id="searchContent"
                      onChange={handleInputChange}
                      value={searchTerm}
                    />
                  </form>

                  {selectedData.length > 0 && (
                    <div id="sk_selected" className="text-block-371">
                      {t('Selected')}
                    </div>
                  )}
                  <div className="skill_search_selected active">
                    {selectedData.map((data, index) => (
                      <div
                        className="c_box"
                        key={index}
                        onClick={handleDeselection(data)}
                      >
                        <div className="c_b_header">
                          <img
                            src={getImageURL(data)}
                            height={30}
                            onError={handleImageError}
                            alt=""
                            className="image-34-wide c_img cb"
                          />
                        </div>
                        <div className="c_b">
                          <div className="unit-wide-header-holder">
                            <div className="text-block-39 wide">
                              {data?.data?.name || data.name}
                            </div>
                          </div>
                          <div className="line4 n t" />
                          <div className="text-block-110">{t('Course')}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="skill_search_results">
                    {searchedData.map((data, index) => (
                      <div
                        className="c_box"
                        key={index}
                        onClick={handleSelectedData(data)}
                      >
                        <div className="c_b_header">
                          <img
                            src={getImageURL(data)}
                            onError={handleImageError}
                            height={30}
                            alt=""
                            className="image-34-wide c_img cb"
                          />
                        </div>
                        <div className="c_b">
                          <div className="unit-wide-header-holder">
                            <div className="text-block-39 wide">
                              {data?.data?.name || data.name}
                            </div>
                          </div>
                          <div className="line4 n t" />
                          <div className="text-block-110">{t('Course')}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    className="w-form-done"
                    tabIndex={-1}
                    role="region"
                    aria-label={t('Email Form success')}
                  >
                    <div>
                      {t('Thank you! Your submission has been received!')}
                    </div>
                  </div>
                  <div
                    className="w-form-fail"
                    tabIndex={-1}
                    role="region"
                    aria-label={t('Email Form failure')}
                  >
                    <div>
                      {t(
                        'Oops! Something went wrong while submitting the form.'
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-f">
              <div
                className="div-block-475 confirm_add_skill"
                onClick={handleAddContentBtnClick}
              >
                <div className="text-block-284 add_skill_text">
                  {t('Add Content')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
